import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';

import useTitle from 'hooks/useTitle';

const NoPermission = () => {
  useTitle('Không có quyền truy cập', {
    restoreOnUnmount: true,
  });

  return (
    <React.Fragment>
      <div className='account-pages my-5 pt-sm-5'>
        <Container>
          <Row className='justify-content-center'>
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody>
                  <div className='p-2'>
                    <div className='text-center'>
                      <div className='avatar-md mx-auto'>
                        <div className='avatar-title rounded-circle bg-light'>
                          <i className='bx bxs-lock h1 mb-0 text-danger'></i>
                        </div>
                      </div>
                      <div className='p-2 mt-4'>
                        <h4>You have no permission</h4>
                        <p>You need to be authorized to be able to access this page</p>
                        <div className='mt-4'>
                          <Link to='/login' className='btn btn-danger w-md'>
                            Return
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default NoPermission;
